import React from 'react';

interface ShuttersProps extends React.SVGProps<SVGSVGElement> {
  patternUrl: string;
}

export const Shutters89mmClearViewFaceFit = ({
  patternUrl,
  ...props
}: ShuttersProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="prefix__Layer_1"
      data-name="Layer 1"
      viewBox="0 0 555.2 410"
      preserveAspectRatio="none"
      {...props}
    >
      <defs>
        <pattern
          id="shutters89"
          patternUnits="userSpaceOnUse"
          width="100"
          height="100"
        >
          <image href={patternUrl} x="0" y="0" width="100" height="100" />
        </pattern>
      </defs>
      <defs>
        <linearGradient
          id="prefix__linear-gradient"
          x1={405.95}
          y1={491.31}
          x2={405.95}
          y2={486.11}
          gradientTransform="translate(0 -432)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.02} stopColor="#fff" stopOpacity={0.5} />
          <stop offset={0.37} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.6} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-2"
          x1={405.95}
          y1={524.35}
          x2={405.95}
          y2={519.15}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-3"
          x1={405.95}
          y1={557.3}
          x2={405.95}
          y2={552.1}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-4"
          x1={405.95}
          y1={590.14}
          x2={405.95}
          y2={584.93}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-5"
          x1={405.95}
          y1={623.08}
          x2={405.95}
          y2={617.88}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-6"
          x1={405.95}
          y1={656.02}
          x2={405.95}
          y2={650.82}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-7"
          x1={405.95}
          y1={688.96}
          x2={405.95}
          y2={683.76}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-8"
          x1={405.95}
          y1={721.9}
          x2={405.95}
          y2={716.7}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-9"
          x1={405.95}
          y1={754.85}
          x2={405.95}
          y2={749.64}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-10"
          x1={405.95}
          y1={787.79}
          x2={405.95}
          y2={782.59}
          xlinkHref="#prefix__linear-gradient"
        />
        <linearGradient
          id="prefix__linear-gradient-11"
          x1={42}
          y1={505.26}
          x2={42}
          y2={472.73}
          gradientTransform="translate(0 -432)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.24} stopOpacity={0} />
          <stop offset={1} stopOpacity={0.3} />
        </linearGradient>
        <linearGradient
          id="prefix__linear-gradient-12"
          x1={7084.24}
          y1={505.26}
          x2={7084.24}
          y2={472.73}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-13"
          y1={538.32}
          y2={505.77}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-14"
          x1={7084.24}
          y1={538.32}
          x2={7084.24}
          y2={505.77}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-15"
          y1={571.3}
          y2={538.76}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-16"
          x1={7084.24}
          y1={571.3}
          x2={7084.24}
          y2={538.76}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-17"
          y1={604.1}
          y2={571.56}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-18"
          x1={7084.24}
          y1={604.1}
          x2={7084.24}
          y2={571.56}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-19"
          y1={637.05}
          y2={604.5}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-20"
          x1={7084.24}
          y1={637.05}
          x2={7084.24}
          y2={604.5}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-21"
          y1={670}
          y2={637.46}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-22"
          x1={7084.24}
          y1={670}
          x2={7084.24}
          y2={637.46}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-23"
          y1={702.9}
          y2={670.36}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-24"
          x1={7084.24}
          y1={702.9}
          x2={7084.24}
          y2={670.36}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-25"
          y1={735.9}
          y2={703.35}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-26"
          x1={7084.24}
          y1={735.9}
          x2={7084.24}
          y2={703.35}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-27"
          y1={768.8}
          y2={736.26}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-28"
          x1={7084.24}
          y1={768.8}
          x2={7084.24}
          y2={736.26}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-29"
          y1={801.74}
          y2={769.2}
          xlinkHref="#prefix__linear-gradient-11"
        />
        <linearGradient
          id="prefix__linear-gradient-30"
          x1={7084.24}
          y1={801.74}
          x2={7084.24}
          y2={769.2}
          gradientTransform="matrix(-1 0 0 1 7341.09 -432)"
          xlinkHref="#prefix__linear-gradient-11"
        />
        <style>
          {
            '.prefix__cls-16{fill:none;stroke:#4d4d4d;isolation:isolate}.prefix__cls-16,.prefix__cls-37,.prefix__cls-38{stroke-miterlimit:10}.prefix__cls-3{opacity:.2}.prefix__cls-2{fill:url(#shutters89)}.prefix__cls-4{fill:#4d4d4d}.prefix__cls-5{fill:#333}.prefix__cls-16{stroke-width:.95px;opacity:.15}.prefix__cls-37,.prefix__cls-38{fill:#efefef;stroke:gray;stroke-width:.95px}.prefix__cls-37{opacity:.2}.prefix__cls-38{opacity:.1}'
          }
        </style>
      </defs>
      <path
        style={{
          isolation: 'isolate',
        }}
        opacity={0.2}
        strokeMiterlimit={10}
        fill="none"
        stroke="#4d4d4d"
        d="M0 0h555.2v410H0z"
      />
      <path
        className="prefix__cls-2"
        d="M514.5 13.3H13.3v383.5H542V13.3zm0 356.4h-217v-14h216.9v14zm0-19.1h-217v-27.8h216.9v27.8zm0-33h-217v-27.8h216.9v27.8zm0-32.9h-217v-27.8h216.9v27.8zm0-32.9h-217V224h216.9v27.8zm0-33h-217V191h216.9v27.8zm0-32.9h-217v-27.8h216.9v27.8zm0-32.9h-217v-27.7h216.9V153zm0-33h-217V92.4h216.9V120zm0-32.9h-217V59.3h216.9v27.8zm0-33h-217V40.3h216.9v13.8z"
      />
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M41.2 397.2H12.8V12.8h28.4zm-27.5-.9h26.5V13.7H13.7z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M258.1 40.7H40.3V12.8h217.9v27.9zm-216.9-.9h216V13.7h-216v26.1z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M258.1 397.2H40.3v-27.9h217.9v27.9zm-216.9-.9h216v-26.1h-216v26.1z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M515 40.7H297.1V12.8H515zm-217-.9h216V13.7H298z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M515 397.2H297.1v-27.9H515zm-217-.9h216v-26.1H298z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M542.4 397.2H514V12.8h28.4zm-27.4-.9h26.5V13.7H515z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M278 397.2h-20.8V12.8H278zm-19.9-.8h19.2V13.6h-19.2z"
        />
        <path
          className="prefix__cls-4"
          d="M297.9 397.2h-20.8V12.8h20.8zm-19.9-.8h19.2V13.6H278z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-5"
          d="M13.3 72.7h2.5v35.7h-2.5zM13.3 301.6h2.5v35.7h-2.5z"
        />
      </g>
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-5"
          d="M539.5 72.7h2.5v35.7h-2.5zM539.5 301.6h2.5v35.7h-2.5z"
        />
      </g>
      <path
        fill="url(#prefix__linear-gradient)"
        d="M297.5 54.1h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-2)"
        d="M297.5 87.1h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-3)"
        d="M297.5 120h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-4)"
        d="M297.5 153h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-5)"
        d="M297.5 185.9h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-6)"
        d="M297.5 218.8h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-7)"
        d="M297.5 251.8h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-8)"
        d="M297.5 284.7h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-9)"
        d="M297.5 317.6h216.9v5.3H297.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-10)"
        d="M297.5 350.6h216.9v5.3H297.5z"
      />
      <path className="prefix__cls-16" d="M40.7 40.3h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-11)"
        d="M42.8 40.7h-1.6v32.6l1.6-32.6z"
      />
      <path
        fill="url(#prefix__linear-gradient-12)"
        d="M256 40.7h1.7v32.6L256 40.7z"
      />
      <path className="prefix__cls-16" d="M40.7 73.3h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-13)"
        d="M42.8 73.7h-1.6v32.7l1.6-32.7z"
      />
      <path
        fill="url(#prefix__linear-gradient-14)"
        d="M256 73.7h1.7v32.7L256 73.7z"
      />
      <path className="prefix__cls-16" d="M40.7 106.3h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-15)"
        d="M42.8 106.7h-1.6v32.6l1.6-32.6z"
      />
      <path
        fill="url(#prefix__linear-gradient-16)"
        d="M256 106.7h1.7v32.6l-1.7-32.6z"
      />
      <path className="prefix__cls-16" d="M40.7 139.1h216.9V172H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-17)"
        d="M42.8 139.6h-1.6v32.5l1.6-32.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-18)"
        d="M256 139.6h1.7v32.5l-1.7-32.5z"
      />
      <path className="prefix__cls-16" d="M40.7 172h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-19)"
        d="M42.8 172.5h-1.6v32.6l1.6-32.6z"
      />
      <path
        fill="url(#prefix__linear-gradient-20)"
        d="M256 172.5h1.7v32.6l-1.7-32.6z"
      />
      <path className="prefix__cls-16" d="M40.7 204.9h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-21)"
        d="M42.8 205.5h-1.6V238l1.6-32.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-22)"
        d="M256 205.5h1.7V238l-1.7-32.5z"
      />
      <path className="prefix__cls-16" d="M40.7 237.9h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-23)"
        d="M42.8 238.4h-1.6v32.5l1.6-32.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-24)"
        d="M256 238.4h1.7v32.5l-1.7-32.5z"
      />
      <path className="prefix__cls-16" d="M40.7 270.8h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-25)"
        d="M42.8 271.3h-1.6v32.6l1.6-32.6z"
      />
      <path
        fill="url(#prefix__linear-gradient-26)"
        d="M256 271.3h1.7v32.6l-1.7-32.6z"
      />
      <path className="prefix__cls-16" d="M40.7 303.8h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-27)"
        d="M42.8 304.3h-1.6v32.5l1.6-32.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-28)"
        d="M256 304.3h1.7v32.5l-1.7-32.5z"
      />
      <path className="prefix__cls-16" d="M40.7 336.7h216.9v32.9H40.7z" />
      <path
        fill="url(#prefix__linear-gradient-29)"
        d="M42.8 337.2h-1.6v32.5l1.6-32.5z"
      />
      <path
        fill="url(#prefix__linear-gradient-30)"
        d="M256 337.2h1.7v32.5l-1.7-32.5z"
      />
      <path
        className="prefix__cls-2"
        d="M0 0v410h555.2V0zm542 396.7H13.2V13.2H542z"
      />
      <g className="prefix__cls-3">
        <path
          className="prefix__cls-4"
          d="M554.2 1v408H1V1h553.2M12.3 397.8H543V12.2H12.3v385.6M555.2 0H0v410h555.2V0zM13.3 396.8V13.2H542v383.5H13.3z"
        />
      </g>
      <path
        className="prefix__cls-37"
        d="M541.98 13.24L554.23.99M13.23 396.76L.98 409.01M541.98 396.76l12.25 12.25"
      />
      <path
        className="prefix__cls-38"
        d="M3.37 3.38h547.96M10.96 10.19h533.86M3.37 406.57h547.96M10.96 399.76h533.86M3.21 3.87v403.28M10.02 10.19v389.78M552.06 3.87v403.28M545.25 10.19v389.78"
      />
      <path className="prefix__cls-37" d="M12.71 12.61L1 1" />
    </svg>
  );
};
